{
  "deselectedItem": "Nie zaznaczono {item}.",
  "select": "Zaznacz",
  "selectedAll": "Wszystkie zaznaczone elementy.",
  "selectedCount": "{count, plural, =0 {Nie zaznaczono żadnych elementów} one {# zaznaczony element} other {# zaznaczonych elementów}}.",
  "selectedItem": "Zaznaczono {item}."
}
